export default "__VITE_ASSET__DewS3hS8__"